import React from "react";
import WorkItemCard, { formatDay } from "../../components/messaging/WorkItemCard";

export { formatDay };

// Details, actions and activity for a task linked from the note. The page
// portals this into the editor's parent (inside #clinic-root) and positions it
// under the clicked link; see WorkItemCard for the card itself.
export default function TaskLinkCard({ taskId, ...props }) {
  return <WorkItemCard kind="task" id={taskId} {...props} />;
}
